import { IconCheck } from '@tvg/fuse-icons';
import { FocusCss } from '@tvg/fuse-utils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import IconElement from '../../fuse-icon-element/src/icon-element';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import BaseInput from './baseinput';

const whiteCheckIcon = `${renderToStaticMarkup(<IconCheck />)}`.replace(
	'<svg',
	'<svg fill="#ffffff"',
);

const StyledCheckbox = styled.div.attrs({
	className: 'fuse-checkbox',
})`
	${({ fullWidth, marginBottom }) => `
		display: ${fullWidth ? 'block' : 'inline-block'};
		height: fit-content;
		${marginBottom ? 'margin-bottom: var(--spacing-global-space6);' : ``}
	`}
`;

const StyledCheckboxInput = styled(BaseInput)`
	&:checked:not([disabled]) + label {
		&::before {
			border: var(--border-width-s) solid var(--color-brand-mid);
			background: var(--color-brand-mid);
		}

		&::after {
			transform: scale(1);
			background: center no-repeat;
			background-size: var(--spacing-global-space6);
			background-image: url('data:image/svg+xml,${encodeURIComponent(whiteCheckIcon)}');
			width: var(--spacing-global-space6);
			height: var(--spacing-global-space6);
			position: absolute;
			left: 0;
			top: 0;
			transition: all 0.15s ease;
		}
		&:hover,
		&:focus {
			&::before {
				border: var(--border-width-s) solid var(--color-brand-dark);
				background-color: var(--color-brand-dark);
			}
		}
	}

	&:checked:disabled + label {
		&::before {
			border: var(--border-width-s) solid var(--color-global-grey400);
			background: var(--color-global-grey400);
		}

		&::after {
			transform: scale(1);
			background: center no-repeat;
			background-size: var(--spacing-global-space6);
			background-image: url('data:image/svg+xml,${encodeURIComponent(whiteCheckIcon)}');
			width: var(--spacing-global-space6);
			height: var(--spacing-global-space6);
			position: absolute;
			left: 0;
			top: 0;
			transition: all 0.15s ease;
		}
		&:hover {
			&::before {
				border: var(--border-width-s) solid var(--color-global-grey400);
			}
		}
	}

	&:focus + label {
		${FocusCss};
		&::before {
			border: var(--border-width-s) solid var(--color-brand-dark);
		}
	}

	&:focus:checked:not([disabled]) + label {
		&::before {
			border: var(--border-width-s) solid var(--color-brand-dark);
			background: var(--color-brand-dark);
		}
	}

	&:disabled + label {
		color: var(--color-global-grey400);
		cursor: default;

		&::before {
			border: var(--border-width-s) solid var(--color-global-grey400);
		}

		&:hover {
			&::before {
				border: var(--border-width-s) solid var(--color-global-grey400);
			}
		}
	}

	& + label {
		color: var(--color-global-black);
		line-height: var(--font-line-height-1);

		&:hover,
		&:focus {
			&::before {
				border: var(--border-width-s) solid var(--color-brand-dark);
			}
		}

		&::before {
			content: '';
			border: var(--border-width-s) solid var(--color-global-grey400);
			width: var(--spacing-global-space6);
			height: var(--spacing-global-space6);
			border-radius: var(--border-radius-s);
			margin-right: var(--spacing-global-space4);
			transition: all 0.15s ease;
			flex-shrink: 0;
			display: block;
			background-color: var(--color-global-grey100);
		}
		&::after {
			content: '';
			transform: scale(0);
			background: center no-repeat;
			background-size: var(--spacing-global-space6);
			background-image: url('data:image/svg+xml,${encodeURIComponent(whiteCheckIcon)}');
			width: var(--spacing-global-space6);
			height: var(--spacing-global-space6);
			position: absolute;
			left: 0;
			top: 0;
			transition: all 0.15s ease;
		}
	}
`;

const StyledCheckboxError = styled.div.attrs({
	className: 'fuse-checkbox__error',
	'data-testid': 'some-test-id',
})`
	align-items: center;
	display: flex;
	height: fit-content;
	margin-top: var(--spacing-global-space3);
`;

const StyledErrorIcon = styled(IconElement)``;

const StyledErrorText = styled(TypographyComponent).attrs({
	'data-testid': 'error-test-id',
})`
	margin: 0 0 0 var(--spacing-global-space4);
`;

export {
	StyledCheckbox,
	StyledCheckboxInput,
	StyledCheckboxError,
	StyledErrorIcon,
	StyledErrorText,
};
